"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;

var foundation_1 = require("./foundation");

var globals_1 = require("./globals");

var config = {
  useSystemColorMode: false,
  initialProductMode: 'luxse',
  initialColorMode: 'light'
};
exports.theme = __assign(__assign({
  breakpoints: foundation_1.breakpoints,
  colors: foundation_1.colors,
  sizes: foundation_1.sizes,
  shadows: foundation_1.shadows,
  radiuses: foundation_1.radiuses,
  borders: foundation_1.borders,
  transitions: foundation_1.transitions
}, foundation_1.typography), {
  zIndices: foundation_1.zIndices,
  styles: globals_1.styles,
  config: config
});